module.exports = __webpack_public_path__ + "static/media/carousel-04.8f2c94b7.jpg";